import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

import Mini from "./Mini";
import Full from "./Full";
import ChatSessionContext from "../../contexts/ChatSessionContext";

const ChatWindow = ({ mini, userId, onClose, onMaximize }) => {
  if (mini) {
    return <Mini userId={userId} onClose={onClose} onMaximize={onMaximize} />;
  }

  return <Full userId={userId} />;
};

ChatWindow.propTypes = {
  key: PropTypes.string,
  userId: PropTypes.string,
  sessions: PropTypes.array,
  onClose: PropTypes.func,
  onMaximize: PropTypes.func,
  mini: PropTypes.bool,
};

ChatWindow.defaultProps = {
  key: "1",
  sessionId: "",
  userId: "",
  sessions: [],
  onClose: () => {},
  onMaximize: () => {},
  mini: true,
};

export default ChatWindow;
